import { render, staticRenderFns } from "./StrQuillEditorCorePdf.vue?vue&type=template&id=5ccf44e4&scoped=true&"
import script from "./StrQuillEditorCorePdf.vue?vue&type=script&lang=js&"
export * from "./StrQuillEditorCorePdf.vue?vue&type=script&lang=js&"
import style0 from "./StrQuillEditorCorePdf.vue?vue&type=style&index=0&id=5ccf44e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccf44e4",
  null
  
)

export default component.exports